import { render } from "./Base.vue?vue&type=template&id=b1ebc082&scoped=true&ts=true"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"

import "./Base.vue?vue&type=style&index=0&id=b1ebc082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ebc082"]])

export default __exports__